import { Link, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';

/**
 * PublicNav Component
 * 🧭 Shared top navigation for public (logged-out) pages:
 * About, Mission, Docs, Forum, Privacy Policy, Data Retention.
 *
 * Mobile-safe: stacks the logo above the links on small screens and lets
 * the links wrap with proper vertical spacing, so nothing overlaps on
 * narrow (iPhone-size) viewports.
 *
 * Props:
 * - showPolicyLinks: also render Privacy Policy / Data Retention links
 *   (used on the policy pages themselves)
 */
const BASE_LINKS = [
  { to: '/about', label: 'About' },
  { to: '/mission', label: 'Our Mission' },
  { to: '/docs', label: 'Docs' },
  { to: '/forum', label: 'Forum' },
];

const POLICY_LINKS = [
  { to: '/privacy', label: 'Privacy Policy' },
  { to: '/data-retention', label: 'Data Retention' },
];

const PublicNav = ({ showPolicyLinks = false }) => {
  const { pathname } = useLocation();
  const links = showPolicyLinks ? [...BASE_LINKS, ...POLICY_LINKS] : BASE_LINKS;

  return (
    <nav className="mb-8 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
      <Link to="/" className="text-[#6C5DD3] font-bold text-xl">MnyMny</Link>
      <div className="flex flex-wrap items-center gap-x-4 gap-y-2">
        {links.map(({ to, label }) => (
          <Link
            key={to}
            to={to}
            className={
              pathname === to
                ? 'text-[#6C5DD3] font-medium'
                : 'text-gray-600 hover:text-[#6C5DD3]'
            }
          >
            {label}
          </Link>
        ))}
        <Link to="/login" className="text-[#6C5DD3] hover:text-[#5849B6] underline">Sign In</Link>
      </div>
    </nav>
  );
};

PublicNav.propTypes = {
  showPolicyLinks: PropTypes.bool,
};

export default PublicNav;
